export enum createFaveTypes {
  CREATE_FAVE = 'CREATE_FAVE',
  CREATE_FAVE_SUCCESS = 'CREATE_FAVE_SUCCESS',
  CREATE_FAVE_FAILURE = 'CREATE_FAVE_FAILURE',
}
